//

import React, { useEffect, useState, useRef } from "react";
import { useSelector } from "react-redux";

const OutBoundCallPopup = () => {
  const [transcripts, setTranscripts] = useState([]);
  const SIPCalls = useSelector((state) => state?.SIPCalls);
  const wsRef = useRef(null);

  useEffect(() => {
    const wsUrl = process.env.REACT_APP_VOIP_WEBSOCKET_BASE_URL_TRANSCRIPT;
    if (!wsUrl) {
      console.error("❌ WebSocket URL not defined");
      return;
    }

    if (wsRef.current) wsRef.current.close();

    const ws = new WebSocket(wsUrl);
    wsRef.current = ws;
    setTranscripts([]);

    ws.onopen = () => console.log("✅ Connected to WebSocket");
    ws.onclose = () => console.log("❌ WebSocket disconnected");

    ws.onmessage = (event) => {
      try {
        const data = JSON.parse(event.data);
        if (data?.type === "transcript" && data?.text) {
          const speaker =
            data.channel === "User"
              ? "User"
              : data.channel === "Agent"
              ? "Agent"
              : "Unknown";

          setTranscripts((prev) => [
            ...prev,
            { speaker, text: data.text, timestamp: data.timestamp },
          ]);
        }

        if (data?.type === "call_end") {
          console.log("☎️ Call ended — clearing transcript");
          setTranscripts([]);
          ws.close();
        }
      } catch (err) {
        console.error("Invalid WebSocket message:", event.data);
      }
    };

    return () => ws.close();
  }, [SIPCalls?.sipRecentCallUUID]);

  return (
    <div className="activitie p-4">
      <h5 className="text-center">💬 Live Transcript</h5>
      {transcripts.length > 0 ? (
        transcripts.map((t, i) => (
          <div
            key={i}
            style={{
              display: "flex",
              justifyContent: t.speaker === "User" ? "flex-end" : "flex-start",
              marginBottom: "10px",
            }}
          >
            <div
              style={{
                background: t.speaker === "User" ? "#dcf8c6" : "#f5f5f5",
                padding: "10px 14px",
                borderRadius: "15px",
                maxWidth: "75%",
                boxShadow: "0 1px 2px rgba(0,0,0,0.1)",
                wordWrap: "break-word",
              }}
            >
              <strong
                style={{
                  display: "block",
                  fontSize: "0.8rem",
                  color: "#555",
                  marginBottom: "2px",
                }}
              >
                {t.speaker}
              </strong>
              <span style={{ fontSize: "0.9rem" }}>{t.text}</span>
              <div
                style={{
                  textAlign: "right",
                  fontSize: "0.7rem",
                  color: "#999",
                  marginTop: "4px",
                }}
              >
                {new Date(t.timestamp).toLocaleTimeString([], {
                  hour: "2-digit",
                  minute: "2-digit",
                })}
              </div>
            </div>
          </div>
        ))
      ) : (
        <p className="text-muted">Waiting for live transcript...</p>
      )}
    </div>
  );
};

export default OutBoundCallPopup;
